import React from "react"
import About from "./About"
import Contact from "./Contact"
import Header from "./Header"
import Nav from "./Nav"
import Education from "./Education"
import Footer from "./Footer"
import Experience from "./Experience"
const App = () => {
  return (
    <>
    <Header/>
    <Nav/>
    <About/>
    <Experience/>
    <Education/>
    <Contact/>
    <Footer/>
    </>
  );
}

export default App;
